import complexMilestonesDataHttpRequest from './12_milestones/12_milestonesData.thunk';

export default complexMilestonesDataHttpRequest;
